import React, { memo, useEffect, useState } from "react";
import { Row, Col, Card, InputGroup, Form, Button } from "react-bootstrap";
import DatePicker from 'react-datepicker';
import MultiSelect from 'components/common/MultiSelect';
import { stillageTypes, getActiveCustomers } from 'services/stillageDashboard';
import TagsInput from "react-tagsinput";
import PropTypes from 'prop-types';
import { toast } from "react-toastify";

const FilterContainer = ({ children }) => (<Col className="align-self-end" sm={4}>{children}</Col>);

const SearchRow = ({ filters, setFilters, search, loading }) => {
    const [customers, setCustomers] = useState([]);
    const [menuIsOpen, setMenuIsOpen] = useState(false);
    useEffect(() => {
        let mounted = true;
        getActiveCustomers()
            .then(res => {
                if (mounted)
                    setCustomers(res)
            })
            .catch(() => {
                if (mounted)
                    setCustomers([]);
            });
        return () => { mounted = false; };
    }, []);

    const onInputChange = (inputValue, { action, prevInputValue }) => {
        if (action === 'input-change')
            return inputValue;

        if (action === 'menu-close')
            return '';

        return prevInputValue;
    };

    return (
        <Row className="g-4 mb-4">
            <Col sm={12}>
                <Card>
                    <Card.Body>
                        <Row>
                            <FilterContainer>
                                <Form.Label sm={1}>Required Date</Form.Label>
                                <Col>
                                    <InputGroup>
                                        <Col xs={5}>
                                            <DatePicker
                                                calendarStartDay={1}
                                                id="date-from"
                                                className="form-control"
                                                placeholderText="Select From"
                                                onChange={date =>
                                                    setFilters({
                                                        ...filters,
                                                        requiredDateFrom: date ? new Date(date).toISOString() : null
                                                    })
                                                }
                                                dateFormat={'dd/MM/yyyy'}
                                                selected={filters?.requiredDateFrom ? new Date(filters?.requiredDateFrom) : ''}
                                                isClearable
                                            />
                                        </Col>
                                        <Col xs={2}>
                                            <InputGroup.Text>To</InputGroup.Text>
                                        </Col>
                                        <Col xs={5}>
                                            <DatePicker
                                                calendarStartDay={1}
                                                id="date-to"
                                                className="form-control"
                                                placeholderText="Select To"
                                                onChange={date =>
                                                    setFilters({
                                                        ...filters,
                                                        requiredDateTo: date ? new Date(date).toISOString() : null
                                                    })
                                                }
                                                dateFormat={'dd/MM/yyyy'}
                                                selected={filters?.requiredDateTo ? new Date(filters?.requiredDateTo) : ''}
                                                isClearable
                                            />
                                        </Col>
                                    </InputGroup>
                                </Col>
                            </FilterContainer>
                            <FilterContainer>
                                <Form.Label>Stillage Type</Form.Label>
                                <MultiSelect
                                    options={Array.from(Object.entries(stillageTypes)).map(([key, opt]) => ({
                                        value: key,
                                        label: <span dangerouslySetInnerHTML={{ __html: opt.label }} />,
                                    }))}
                                    onChange={e => setFilters({
                                        ...filters,
                                        stillageType: e.length == 0 ? null : e?.map(x => x.value)
                                    })}
                                    selected={filters?.stillageType}
                                />
                            </FilterContainer>
                            <FilterContainer>
                                <Form.Label>Customer</Form.Label>
                                <MultiSelect
                                    options={customers?.map(x => {
                                        return {
                                            value: x.code,
                                            label: x.name
                                        }
                                    })}
                                    onChange={e => setFilters({
                                        ...filters,
                                        customer: e.length == 0 ? null : e?.map(x => x.value)
                                    })}
                                    selected={filters?.customer}
                                    closeMenuOnSelect={false}
                                    isSearchable={true}
                                    onSelectResetsInput={false}
                                    onInputChange={onInputChange}
                                    onFocus={() => setMenuIsOpen(true)}
                                    onBlur={() => setMenuIsOpen(false)}
                                    menuIsOpen={menuIsOpen}
                                />
                            </FilterContainer>
                        </Row>
                        <Row>
                            <FilterContainer>
                                <Form.Label>Query</Form.Label>
                                <Form.Control
                                    placeholder="Search By Customer Code, Name Or Job No."
                                    value={filters?.query}
                                    onChange={e => setFilters({ ...filters, query: e.target.value })}
                                ></Form.Control>
                            </FilterContainer>
                            <FilterContainer>
                                <Form.Label>Stillage Nos.</Form.Label>
                                <TagsInput
                                    value={filters?.stillageNo || []}
                                    onChange={e => setFilters({ ...filters, stillageNo: e ?? null })}
                                    addOnBlur={true}
                                    addOnPaste={true}
                                    validate={tag => !isNaN(Number(tag))}
                                    onValidationReject={() => toast.error('Please enter a number!')}
                                    onlyUnique={true}
                                    tagProps={{
                                        className: 'react-tagsinput-tag bg-primary bg-gradient text-light shadow-sm badge py-2',
                                        classNameRemove: 'react-tagsinput-remove'
                                    }}
                                    inputProps={{
                                        className: 'react-tagsinput-input',
                                        placeholder: 'Enter a number...'
                                    }}
                                />
                            </FilterContainer>
                            <FilterContainer>
                                <Button
                                    disabled={loading}
                                    onClick={() => search(true, filters)}
                                >Search</Button>
                            </FilterContainer>
                        </Row>
                    </Card.Body>
                </Card>
            </Col>
        </Row>
    )
}

SearchRow.propTypes = {
    filters: PropTypes.object,
    setFilters: PropTypes.func,
    search: PropTypes.func,
    loading: PropTypes.bool
};
FilterContainer.propTypes = {
    children: PropTypes.node,
};

export default memo(SearchRow);